/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import BaseModal from 'src/common/components/Modal';
import { makeStyles, Grid } from '@material-ui/core';
import FullTable from 'src/common/components/FullTable';
import { columnsNotify } from './utils/list_data';
import CustomButton from 'src/common/components/CustomButton';
import { usersAPI } from 'src/api/modules/users';
import { sessionsAPI } from 'src/api/modules/sessions';
import notice from 'src/common/components/Notice';
import EditorText from 'src/common/components/EditorText';
import {
	templateSignatures,
	templateSignaturesFilial,
} from './utils/template-signatures';

const useStyles = makeStyles({
	subTitle2: {
		fontSize: 21,
		marginBottom: 15,
	},
	containerButtons: {
		flexDirection: 'row',
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'flex-end',
		width: '100%',
	},
});

const NotifyChanges = ({ open, setOpen, idSession, organID, dataSession }) => {
	const classes = useStyles();
	const filial = localStorage.getItem('type');
	const [allSelectedEnviar, setAllSelectedEnviar] = useState([]);
	const [users, setUsers] = useState([]);
	const [mailNotifyChanges, setMailNotifyChanges] = useState();
	const markBtnLabel =
		allSelectedEnviar.length === users.length ? 'Desmarcar todos' : 'Marcar todos';

	useEffect(() => {
		if (organID) getUsers(organID);
		setMailNotifyChanges(mailTemplateNotify);
	}, [organID]);

	const onCheckboxEnviar = (id) => {
		if (allSelectedEnviar.includes(id)) {
			setAllSelectedEnviar(allSelectedEnviar.filter((delId) => delId != id));
		} else {
			setAllSelectedEnviar([...allSelectedEnviar, id]);
		}
	};

	const markAllEnviar = () => {
		if (allSelectedEnviar.length === users.length) {
			setAllSelectedEnviar('');
		} else {
			setAllSelectedEnviar(users.map((user) => user.id));
		}
	};

	const getUsers = (organID) => {
		usersAPI
			.getUsersByOrgan(organID)
			.then((response) => {
				if (response.usuarios && response.usuarios.length > 0) {
					let usersName = [];
					response.usuarios.forEach((item) => {
						usersName.push({
							id: item.id,
							name: `${item.nombre} ${item.apellidoPaterno} ${item.apellidoMaterno}`,
							sector:
								item.sector === 'SG'
									? 'Sector Gobierno'
									: item.sector === 'ST'
									? 'Sector Trabajador'
									: item.sector === 'SE'
									? 'Sector Empresarial'
									: item.sector === ''
									? 'Sin Sector'
									: item.sector,
							position:
								item.cargo === 'PR'
									? 'Propietario'
									: item.cargo === 'SU'
									? 'Suplente'
									: item.cargo === 'TI'
									? 'Titular'
									: item.cargo === 'SUP'
									? 'Suplente'
									: item.cargo === ''
									? 'Sin Cargo'
									: item.cargo,
						});
					});

					setUsers(usersName);
				} else {
					notice('No se encontraron resultados', 'info');
					setUsers([]);
				}
			})
			.catch(() => {
				notice('Ha ocurrido un problema con la solicitud', 'info');
			});
	};

	const post = () => {
		let listUsers = [...new Set(allSelectedEnviar)];
		let bodyNotifyChanges = {
			mensajes: mailNotifyChanges,
			usuariosIds: listUsers,
		};

		sessionsAPI
			.postNotifyChanges(idSession, bodyNotifyChanges)
			.then((response) => {
				if (listUsers.length > 0)
					notice(
						'Se han notificado los cambios a los usuarios convocados y usuarios seleccionados',
						'success'
					);
				else
					notice(
						'Se han notificado los cambios a los usuarios convocados a la sesión',
						'success'
					);
			})
			.catch(() => {
				notice('Ha ocurrido un problema con la solicitud', 'error');
			});

		setOpen(false);
	};

	const firma = filial
		? templateSignaturesFilial(dataSession)
		: templateSignatures(dataSession);

	const mailTemplateNotify =
		`<p><strong>#usuario#,</strong></p>
		<br>
		<p>Se hace de su conocimiento que, a solicitud de la Administración, se actualiza la documentación del <strong> (ingrese su cambio) </strong> orden del día.</p>
		<br>
		<p>La sesión número <strong><a href="` +
		window.location.href +
		`" target="_blank" style="color: rgb(0,0,0);">` +
		dataSession.numero_sesion +
		`</a></strong> del Organo Colegiado <strong>` +
		dataSession.nameOrgan +
		`</strong> ha sido actualizada.</p>
		<br>
		<br>
		<b>Atentamente</b>
		<br>
		<br> ` +
		firma;

	return (
		<BaseModal
			open={open}
			mainText="Notificar Cambios"
			onClose={() => setOpen(false)}
			onCancel={() => setOpen(false)}
			onConfirm={() => post()}
			confirmLabel="Enviar Notificación"
			maxWidth="md"
		>
			<div className={classes.subTitle2}>Mensaje a Notificar</div>
			<Grid container className={classes.root} spacing={2}>
				<Grid item md={12}>
					<EditorText
						defaultHTML={mailNotifyChanges}
						setValueEnd={setMailNotifyChanges}
					/>
				</Grid>
				<div style={{ width: '100%' }}>
					<div className={classes.containerButtons}>
						<CustomButton
							mainText={markBtnLabel}
							onClick={markAllEnviar}
							className={'mt-lg-5'}
						/>
					</div>
					<FullTable
						title="Destinatarios a Enviar Notificación"
						items={users}
						columns={columnsNotify(onCheckboxEnviar, allSelectedEnviar)}
						paginateOptions={[]}
					/>
				</div>
			</Grid>
		</BaseModal>
	);
};

export default NotifyChanges;
